import TimeSync from './time_sync.js';

const timeSync = new TimeSync();

function handleServerTimeResync() {
  if (document.hidden) return;

  timeSync.reSync();
}
/**
 * This is triggered when:
 *  - the browser tab is hidden and then shown again.
 *  - mobile app is in background and then foreground
 */
document.addEventListener('visibilitychange', handleServerTimeResync);

export default {
  timeSync,

  get offset() {
    return this.timeSync.offset;
  },

  get syncedAt() {
    return this.timeSync.syncedAt;
  },

  get timeSyncedAtJSON() {
    if (!this.timeSync.syncedAt) return null;

    return new Date(this.timeSync.syncedAt).toJSON();
  },

  sync() {
    return this.timeSync.reSync();
  },

  now() {
    if (Math.abs(this.offset) > 1000) {
      return new Date(+new Date() + this.offset);
    }
    return new Date();
  },

  toJSON() {
    return this.now().toJSON();
  },
};
